import {Route} from "react-router-dom";
import React from "react";
import AuthGuard from "../authGurd/AuthGuard";
import {CONTENT_TYPE} from "./enums";

export default {
    isPersian(string) {
        return /^[\u0600-\u06FF\s\d-/\\]+$/.test(string);
    },
    hexToHsv(hex) {
        let r = 0, g = 0, b = 0;
        // 3 digits
        if (hex.length === 4) {
            r = "0x" + hex[1] + hex[1];
            g = "0x" + hex[2] + hex[2];
            b = "0x" + hex[3] + hex[3];

            // 6 digits
        } else if (hex.length === 7) {
            r = "0x" + hex[1] + hex[2];
            g = "0x" + hex[3] + hex[4];
            b = "0x" + hex[5] + hex[6];
        }

        r /= 255
        g /= 255
        b /= 255

        const max = Math.max(r, g, b), min = Math.min(r, g, b);
        let h, s, v = max;

        const d = max - min;
        s = max === 0 ? 0 : d / max;

        if (max === min) {
            h = 0; // achromatic
        } else {
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }

            h /= 6;
        }

        return [h, s, v];
    },
    hsvToHex(h, s, v) {
        let r, g, b;

        const i = Math.floor(h * 6);
        const f = h * 6 - i;
        const p = v * (1 - s);
        const q = v * (1 - f * s);
        const t = v * (1 - (1 - f) * s);

        switch (i % 6) {
            case 0:
                r = v
                g = t
                b = p;
                break;
            case 1:
                r = q
                g = v
                b = p;
                break;
            case 2:
                r = p
                g = v
                b = t;
                break;
            case 3:
                r = p
                g = q
                b = v;
                break;
            case 4:
                r = t
                g = p
                b = v;
                break;
            case 5:
                r = v
                g = p
                b = q;
                break;
        }

        r *= 255;
        g *= 255;
        b *= 255;
        let rStr = parseInt(r).toString(16);
        let gStr = parseInt(g).toString(16);
        let bStr = parseInt(b).toString(16);

        if (rStr.length === 1)
            rStr = "0" + rStr;
        if (gStr.length === 1)
            gStr = "0" + gStr;
        if (bStr.length === 1)
            bStr = "0" + bStr;

        return "#" + rStr + gStr + bStr;
    },
    joinSafe(array, separator) {
        return array.filter((item) => !!item).join(separator)
    },
    onContentClick(type, courseId, classId, courseCategory, url, setAppRequiredOpen, navigate) {
        switch (type) {
            case CONTENT_TYPE.COURSE:
                navigate(`/course/${courseId}`)
                break;
            case CONTENT_TYPE.CLASS:
                navigate(`/class/show/${classId}`)
                break;
            case CONTENT_TYPE.PROFILE:
                navigate(`/profile`)
                break;
            case CONTENT_TYPE.LEITNER:
            case CONTENT_TYPE.DICTIONARY:
                setAppRequiredOpen(true)
                break;

            case CONTENT_TYPE.COURSE_CATEGORY:
                navigate(`/courseCategory/${courseCategory.id}`, {
                    state: {
                        icon: courseCategory.icon,
                        name: courseCategory.name
                    }
                })
                break;
            case CONTENT_TYPE.URL:
                window.open(url, '_blank', 'noreferrer');
                break;
        }
    },
    routeMap(route, idx, user) {
        return <Route
            key={idx}
            exact={route.exact}
            name={route.name}
            path={route.path}
            element={route.mostLogin ? <AuthGuard user={user}>
                <route.component/>
            </AuthGuard> : <route.component/>}/>
    },
    mainRouteMap(route, idx) {
        let res = []
        res.push(route.otherPath?.map(r => <Route
            key={idx}
            exact={route.exact}
            name={route.name}
            path={r.path + "/*"}
            element={<r.component/>}/>))
        res.push(<Route
            key={idx}
            exact={route.exact}
            name={route.name}
            path={route.path + "/*"}
            element={<route.component/>}/>)
        return res
    }

}
